// extracted by mini-css-extract-plugin
module.exports = {"container":"optionCardView_container__5ZveY","span":"optionCardView_span__2zaWA"};